export { PhotoshopWidget } from './UI/photoshopWidget.js';
